export const MODULE_LOADING = "MODULE_LOADING";
export const MODULE_ADD = "MODULE_ADD";
export const MODULE_UPDATE = "MODULE_UPDATE";
export const MODULE_DELETE = "MODULE_DELETE";
export const MODULE_LIST = "MODULE_LIST";



// WEBPACK FOOTER //
// ./src/actions/module/types.js